<div class="flex">
  <div class="flex-grow-1">
    <h2 class="sub-header-bar mb-1 mt-1">Manage Non-Movement Transactions</h2>
  </div>
  <div class="flex-shrink-1">
    <div class="pb-2">
      <button
        pButton
        type="button"
        label="Create"
        icon="fa fa-plus"
        iconPos="right"
        class="ui-button ui-button-success"
        (click)="showTransactionFormDialog()"
      ></button>
      <button
        pButton
        type="button"
        label="Import"
        icon="fa fa-upload"
        iconPos="right"
        class="ui-button ui-button-secondary"
        (click)="showUploadNonMovementTransactionsDialog = true"
      ></button>
    </div>
  </div>
</div>
<div ngClass="mt-30">
  <form (ngSubmit)="search()">
    <div class="ui-g filterPanel">
      <div class="ui-g-12 ui-md-3 ui-lg-3">
        <span class="mt-5">
          <organisation-select-list
            [minTextLength]="1"
            (valueChange)="onOrganisationChange($event)"
          >
          </organisation-select-list>
        </span>
      </div>
      <div class="ui-g-12 ui-md-3 ui-lg-3">
        <span class="mt-5">
          <p-dropdown
            [options]="departmentsFilterList"
            [style]="{ width: '100%' }"
            (onChange)="onDepartmentChange($event.value)"
            placeholder="Select a Department"
          >
          </p-dropdown>
        </span>
      </div>
      <div class="ui-g-12 ui-md-2 ui-lg-2">
        <span class="md-inputfield">
          <p-calendar
            [(ngModel)]="filterVal.filters.from.value"
            name="createdFrom"
            dateFormat="dd/mm/yy"
            [maxDate]="todayDate"
          ></p-calendar>
          <label>From</label>
        </span>
      </div>

      <div class="ui-g-12 ui-md-2 ui-lg-2">
        <span class="md-inputfield">
          <p-calendar
            [(ngModel)]="filterVal.filters.to.value"
            name="createdTo"
            dateFormat="dd/mm/yy"
            [maxDate]="todayDate"
            [minDate]="filterVal.filters.from.value || null"
          ></p-calendar>
          <label>To</label>
        </span>
      </div>
      <div class="ui-g-12 ui-md-2 ui-lg-2">
        <span class="md-inputfield">
          <p-dropdown
            name="transactionTypes"
            [options]="transactionPrefixes"
            [(ngModel)]="filterVal.filters.transactionTypeId.value"
            filter="true"
            placeholder="Select a transaction Type"
            [ngStyle]="{ 'max-width': '206px;' }"
          ></p-dropdown>
        </span>
      </div>
      <div class="ui-g-12 ui-md-2 ui-lg-2 text-center">
        <p-checkbox
          name="awaitingInvoice"
          [(ngModel)]="filterVal.filters.awaitinginvoice.value"
          [binary]="true"
          label="Awaiting Invoice"
        >
        </p-checkbox>
      </div>
      <div class="ui-g-12 ui-md-1 ui-lg-1 pull-right">
        <button
          pButton
          type="submit"
          label="Search"
          class="ui-button btn-to-right"
          icon="fa fa-search"
          iconPos="right"
        ></button>
      </div>
    </div>
  </form>
  <div *ngIf="page.items">
    <p-table
      [value]="page.items"
      [columns]="cols"
      [sortField]="filterVal.sortField"
      [sortOrder]="filterVal.sortOrder"
      [rows]="filterVal.rows"
      [first]="filterVal.first"
      [rowsPerPageOptions]="[5, 10, 20, 50, 100]"
      [paginator]="true"
      [pageLinks]="8"
      [totalRecords]="page.total"
      [lazy]="true"
      (onLazyLoad)="onGridLazyLoad($event)"
      resizableColumns="true"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="width: 3em">
            <p-checkbox
              [(ngModel)]="toggleTransactionLines"
              binary="true"
              (click)="toggleTransactionsCheckbox()"
            >
            </p-checkbox>
          </th>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field">
            {{ col.header }}
            <p-sortIcon
              [field]="col.field"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            >
            </p-sortIcon>
          </th>
          <th style="width: 8em"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
        <tr>
          <td class="text-center">
            <p-checkbox
              [(ngModel)]="rowData.isChecked"
              binary="true"
              (click)="handleTransactionSelectionChange()"
              *ngIf="!rowData.transactionLinesId"
            >
            </p-checkbox>
            <span *ngIf="rowData.transactionLinesId && !rowData.isInvoiced"
              ><i class="pi pi-spin pi-spinner text-center" style="font-size: 1rem"></i
            ></span>
          </td>
          <td
            *ngFor="let col of columns"
            [class.text-center]="col.field != 'descriptionId' && col.field != 'organisationId'"
          >
            <ng-container *ngIf="col.field == 'transactionNumber'">
              <span>{{ rowData[col.field] }}</span>
            </ng-container>
            <ng-container *ngIf="col.field == 'amount'">
              <span>{{ rowData[col.field] | currency : 'GBP' : 'symbol' : '1.2-2' }}</span>
            </ng-container>
            <ng-container *ngIf="col.field == 'createdOn'">
              <span>{{ rowData[col.field] | datex : 'DD/MM/YYYY' }}</span>
            </ng-container>
            <ng-container *ngIf="col.field == 'organisationId'">
              <span
                ><a href="/app/organisations/{{ rowData.organisation.id }}" target="_blank">{{
                  rowData.organisation.name
                }}</a></span
              >
            </ng-container>
            <ng-container *ngIf="col.field == 'transactionLinePrefixId'">
              <span>{{ rowData.transactionLinePrefix.type }}</span>
            </ng-container>
            <ng-container *ngIf="col.field == 'descriptionId'">
              <span
                >{{
                  rowData.customDescription
                    ? rowData.customDescription
                    : rowData.description.description
                }}
                ({{ rowData.description.xeroCode }})</span
              >
            </ng-container>
            <ng-container *ngIf="col.field == 'departmentName'">
              <span>{{ rowData.departmentName }}</span>
            </ng-container>
          </td>
          <td>
            <div class="ui-g-4">
              <span
                class="fa fa-info link"
                title="Show History"
                (click)="showHistory(rowData.id)"
              ></span>
            </div>
            <ng-template [ngIf]="!rowData.isInvoiced">
              <div class="ui-g-4">
                <span
                  class="fa fa-pencil link"
                  (click)="modifyTransaction(rowData)"
                  title="Edit"
                ></span>
              </div>
              <div class="ui-g-4">
                <span
                  class="fa fa-trash link text-danger"
                  (click)="deleteTransaction(rowData)"
                  title="Delete"
                ></span>
              </div>
            </ng-template>
            <ng-template [ngIf]="rowData.isInvoiced">
              <i>Invoiced</i>
            </ng-template>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div class="ui-g-12">
      <button
        pButton
        label="Process Transactions"
        class="ui-button ui-button-success btn-to-right pull-right"
        icon="fa fa-check"
        iconPos="right"
        (click)="processSelectedTransactions()"
        [disabled]="selectedTransactions?.length < 1"
      ></button>
      <button
        *ngIf="selectedTransactions?.length > 1"
        pButton
        label="Delete Transactions"
        class="ui-button ui-button-danger btn-to-right pull-right"
        icon="fa fa-trash"
        iconPos="right"
        (click)="deleteSelectedTransactions()"
      ></button>
    </div>
  </div>
</div>

<p-dialog
  #saveTransactionDialog
  [header]="nonTransactionForm?.value?.id ? 'Update Transaction' : 'Create Transaction'"
  [(visible)]="nonTransactionForm"
  [responsive]="true"
  [modal]="true"
  closable="true"
  *ngIf="isTransactionFormEnabled"
>
  <div class="ui-g-12" style="position: relative; padding: 0">
    <form
      *ngIf="nonTransactionForm"
      (ngSubmit)="saveTransaction(nonTransactionForm?.value)"
      [formGroup]="nonTransactionForm"
    >
      <div class="form-group ui-g-12">
        <div class="ui-grid-row">
          <div class="ui-g-3 ui-sm-12">
            <span class="mt-5">
              <organisation-select-list
                [minTextLength]="1"
                (valueChange)="onNewTransactionOrganisationChange($event)"
                [selectedOrganisationId]="nonTransactionForm?.value?.organisationId"
              >
              </organisation-select-list>
            </span>
            <input
              type="hidden"
              formControlName="organisationId"
              [ngModel]="nonTransactionForm?.value?.organisationId"
            />
          </div>
          <div class="ui-g-3 ui-sm-12">
            <span class="mt-5">
              <p-dropdown
                [options]="departmentsDialogList"
                [style]="{ width: '100%' }"
                formControlName="departmentId"
                [placeholder]="'Select a Department'"
                styleClass="form-component"
                appendTo="body"
              >
              </p-dropdown>
            </span>
          </div>
          <div class="ui-g-3 ui-sm-12">
            <p-dropdown
              [options]="transactionPrefixes"
              formControlName="transactionLinePrefixId"
              autoWidth="false"
              styleClass="form-component"
              tabindex="2"
              appendTo="body"
            >
            </p-dropdown>
          </div>
          <div class="ui-g-3 ui-sm-12">
            <p-dropdown
              [options]="descriptionTypes"
              formControlName="descriptionId"
              autoWidth="false"
              styleClass="form-component"
              tabindex="3"
              aria-placeholder="Created Date"
              appendTo="body"
            >
            </p-dropdown>
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-g-4 ui-sm-12">
            <input
              type="text"
              pInputText
              class="ui-g-12"
              formControlName="customDescription"
              tabindex="4"
              aria-placeholder="Use a custom Description"
              placeholder="Use a custom description"
              appendTo="body"
            />
          </div>
          <div class="ui-g-4 ui-sm-12">
            <p-calendar
              formControlName="createdOn"
              name="createdOn"
              dateFormat="dd/mm/yy"
              tabindex="5"
              aria-placeholder="Created"
              placeholder="Created"
              appendTo="body"
              [minDate]="maxBackDate"
              [maxDate]="todayDate"
            ></p-calendar>
          </div>
          <div class="ui-g-4 ui-sm-12">
            <input
              pInputText
              id="amount"
              formControlName="amount"
              tabindex="6"
              type="number"
              maxlength="5"
              aria-placeholder="Amount"
              placeholder="Amount"
            />
          </div>
        </div>
        <div></div>
      </div>
      <div class="ui-g-12">
        <button
          pButton
          type="submit"
          [label]="nonTransactionForm?.value?.id ? 'Update' : 'Add'"
          class="ui-button ui-button-success btn-to-right pull-right"
          [disabled]="savingTransactions"
          tabindex="7"
        ></button>
        <button
          pButton
          type="reset"
          label="Cancel"
          class="ui-button ui-button-danger btn-to-right pull-right"
          (click)="isTransactionFormEnabled = false"
          tabindex="7"
        ></button>
      </div>
    </form>
    <br />
  </div>
</p-dialog>

<p-dialog
  #uploadNonMovementTransactionsDialog
  [(visible)]="showUploadNonMovementTransactionsDialog"
  [responsive]="true"
  [modal]="true"
  closable="true"
  [showHeader]="true"
  [contentStyle]="{ 'max-width': '960px' }"
  [baseZIndex]="1000"
>
  <div>
    <p-panel [style]="{ 'margin-bottom': '20px' }">
      <p-header>
        <div ngClass="">
          <a
            href="{{ sample_spreadsheet_file }}"
            download=""
            type="button "
            pButton
            icon="fa fa-download"
            label="Sample Spreadsheet"
            class=""
          ></a>
        </div>
      </p-header>
      <div [ngStyle]="{ 'overflow-y': 'auto' }">
        <img src="assets/images/non_movement_transaction_sample.png" />
      </div>
    </p-panel>

    <p-panel [showHeader]="false">
      <div class="">
        <data-import [importDataType]="5"></data-import>
      </div>
    </p-panel>
    <br />
  </div>
</p-dialog>

<p-confirmDialog
  key="confirmDialog"
  header="Confirmation"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Yes"
  rejectLabel="No"
>
</p-confirmDialog>

<p-dialog
  [header]="progressBarTitle"
  modal="true"
  [(visible)]="isProcessing"
  appendTo="body"
  (onHide)="isProcessing = false"
>
  <p-progressBar mode="indeterminate"></p-progressBar>
</p-dialog>
<p-dialog
  #transactionHistoryDialog
  header="Transaction History"
  [(visible)]="enableTransactionHistoryDialog"
  [responsive]="true"
  [modal]="true"
  closable="true"
  *ngIf="transactionHistoryTimeline"
  styleClass="ui-md-6 ui-lg-6 ui-sm-12"
>
  <timeline
    [items]="transactionHistoryTimeline"
    [iconMapping]="{ time: 'icon-clock1_666' }"
    emptyMessage="No history to display"
  ></timeline>
</p-dialog>
